import React, { ReactElement } from 'react';
import { Flex, Button } from '@cognite/cogs.js';
import styled from 'styled-components/macro';
import pluralize from 'pluralize';
import {
  CopyRulesPlaceholderType,
  getCountsFromCopyPlaceholder,
} from '../helpers';

/** Shows information about how many rulesets and rules are in each milestone found in *copyRulesPlaceholder*. */
export const SelectedRulesInformation = ({
  copyRulesPlaceholder,
}: {
  copyRulesPlaceholder: CopyRulesPlaceholderType;
}) => {
  const { rulesetsCount, rulesCount } =
    getCountsFromCopyPlaceholder(copyRulesPlaceholder);

  if (!rulesetsCount && !rulesCount) return <></>;

  return (
    <div>
      {`${pluralize('ruleset', rulesetsCount, true)}, `}
      {`${pluralize('rule', rulesCount, true)} selected`}
    </div>
  );
};

type StepHeaderProps = {
  backButtonLabel: string;
  onBackButtonClick: VoidFunction;
  backButtonContent: ReactElement;
  content: ReactElement;
  selectAllButtonLabel: string;
  onSelectAllButtonClick: VoidFunction;
  selectAllDisabled?: boolean;
};

export const StepHeader = ({
  backButtonLabel,
  onBackButtonClick,
  backButtonContent,
  content,
  selectAllButtonLabel,
  onSelectAllButtonClick,
  selectAllDisabled = false,
}: StepHeaderProps) => (
  <StyledHeader
    alignItems="center"
    direction="row"
    justifyContent="space-between"
  >
    <Flex alignItems="center" direction="row" gap={5}>
      <Button
        aria-label={backButtonLabel}
        icon="ArrowLeft"
        onClick={onBackButtonClick}
        type="ghost"
      >
        <Flex alignItems="center" direction="row" gap={5}>
          {backButtonContent}
        </Flex>
      </Button>

      {content}
    </Flex>

    <Button
      aria-label={selectAllButtonLabel}
      type="ghost"
      onClick={onSelectAllButtonClick}
      disabled={selectAllDisabled}
    >
      Select all
    </Button>
  </StyledHeader>
);

const StyledHeader = styled(Flex)`
  margin: 0.5rem 0;
  .cogs-title-5 {
    padding: 0.5rem 0;
  }
`;
